/* global jQuery */

import OrderMinMaxFormValidation from '../order-min-max-form-validation';

/**
 * Manages Vendor settings form validation on store/settings page of vendor dashboard
 *
 * @param {jQuery}   $        jQuery object
 * @param {Window}   window   object
 * @param {Document} document object
 *
 * @since 3.12.0
 */
( function ( $, window, document ) {
    $( document ).ready( function () {
        const MINIMUM_ORDER_FIELD_SELECTOR = $( '#min_amount_to_order' );
        const MAXIMUM_ORDER_FIELD_SELECTOR = $( '#max_amount_to_order' );

        new OrderMinMaxFormValidation( MINIMUM_ORDER_FIELD_SELECTOR, MAXIMUM_ORDER_FIELD_SELECTOR );
    } );
} )( jQuery );
